import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import { FileText, Image } from 'lucide-react';
import { useCallback } from 'react';
import { useRecoilValue } from 'recoil';
import { FileClose } from '@/components/Icons/FileClose';
import { LoadingIcon } from '@/components/Icons/LoadingIcon';
import { fileContainsUploadUrlSelector, fileHasUploadErrorSelector, } from '@/state/session';
export const UploadCard = ({ fileName, handleClose, id, content_type, }) => {
    const hasUploadUrl = useRecoilValue(fileContainsUploadUrlSelector(id));
    const hasUploadError = useRecoilValue(fileHasUploadErrorSelector(id));
    const handleCloseButton = useCallback((e) => {
        e.preventDefault();
        if (handleClose) {
            handleClose(e);
        }
    }, [handleClose]);
    const iconByType = () => {
        const size = 16;
        if (content_type.includes('image')) {
            return _jsx(Image, { size: size, color: "var(--color-foreground-muted)" });
        }
        return _jsx(FileText, { size: size, color: "var(--color-foreground-muted)" });
    };
    const renderIcon = () => {
        if (!hasUploadUrl) {
            return _jsx(LoadingIcon, { size: "small" });
        }
        if (hasUploadUrl && !hasUploadError) {
            return (_jsx("div", { className: "relative flex items-center justify-center overflow-hidden", children: iconByType() }));
        }
        return null;
    };
    return (_jsxs("div", { className: cn('bg-surface-button-secondary relative mb-0 flex h-full w-32 items-center gap-1 rounded-md px-2 py-1 text-ellipsis whitespace-nowrap'), style: {
            opacity: hasUploadUrl ? 1 : 0.5,
            filter: hasUploadError ? 'grayscale(100%)' : 'none',
        }, children: [renderIcon(), _jsx("span", { className: "w-full truncate text-xs leading-4 font-semibold", children: fileName }), (hasUploadUrl || hasUploadError) && (_jsx("span", { role: "button", onClick: handleCloseButton, onKeyDown: handleCloseButton, tabIndex: 0, className: "cursor-pointer", children: _jsx(FileClose, { color: "var(--color-foreground-muted)" }) }))] }));
};
